import React, { useState } from 'react';
import { Bell, User } from 'lucide-react';
import NotificationsPopup from './NotificationsPopup';

const Header: React.FC = () => {
  const [showNotifications, setShowNotifications] = useState(false);

  const toggleNotifications = () => {
    setShowNotifications(!showNotifications);
  };

  return (
    <header className="bg-teal-700 text-white px-4 py-3">
      <div className="flex items-center justify-between max-w-7xl mx-auto">
        {/* Left section with logo */}
        <div className="flex items-center">
          {/* TecMI Logo */}
          <img 
            src="/logo.png" 
            alt="TecMI Logo" 
            className="h-10 w-auto"
          />
        </div>

        {/* Center greeting */}
        <div className="hidden md:block">
          <h1 className="text-lg font-medium">Hola, PABLO VILLARREAL LAMBERTA</h1>
        </div>

        {/* Right section with icons */}
        <div className="flex items-center space-x-3">
          <button 
            onClick={toggleNotifications}
            className="p-2 hover:bg-teal-600 rounded-lg transition-colors relative"
          >
            <Bell size={20} />
            <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs rounded-full w-5 h-5 flex items-center justify-center">
              1
            </span>
          </button>
          
          <div className="p-2">
            <User size={20} />
          </div>
        </div>
      </div>

      {/* Notifications Popup */}
      {showNotifications && <NotificationsPopup onClose={toggleNotifications} />}
    </header>
  );
};

export default Header;